// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"5dcd69c9","513":"11121ad7","703":"3967ee70","787":"7971d4a0"}[chunkId] + ".chunk.js";
};